import { formatDate } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary.utils';
import { useLocation } from 'react-router-dom';

export const useFinishDateOverallSummaryLogic = ({ api }) => {
    const { pathname } = useLocation();
    const activityPredictionData = api.getActivityPrediction.data;

    const isActivityDone = activityPredictionData?.status?.name === 'DONE';

    const plannedFinishDate = formatDate(activityPredictionData?.planedFinishDate);
    const optimisticForecastedData = isActivityDone ? 'Done' : formatDate(activityPredictionData?.optimisticFinishDate);
    const bestForecastedData = isActivityDone ? 'Done' : formatDate(activityPredictionData?.bestFinishDate);
    const pessimisticForecasted = isActivityDone ? 'Done' : formatDate(activityPredictionData?.pessimisticsFinishDate);
    const baselineFinishDate = formatDate(activityPredictionData?.baselineFinishDate);

    return {
        logic: {
            pathname,
            plannedFinishDate,
            optimisticForecastedData,
            bestForecastedData,
            pessimisticForecasted,
            baselineFinishDate,
        },
    };
};
